module.exports = __webpack_public_path__ + "img/manual-deduct.bae7b1fd.svg";